module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_about-3a289fc370f7d68a90d868c2af02ca81.png";